import config from 'config';
import React from 'react';
import PropTypes from 'prop-types';

const PackageSelector = React.createClass({
  propTypes: {
    currentPackageId: PropTypes.number.isRequired,
    onChangePackage: PropTypes.func.isRequired,
    packages: PropTypes.array
  },

  handleChange: function(event) {
    let packageId = parseInt(event.target.value, 10);
    this.props.onChangePackage(packageId);
  },

  render: function() {
    let { packages, currentPackageId } = this.props;
    return packages.length > 1 ? (
      <div className="syos-performance-selector">
        <select
          tabIndex="4"
          className="syos-performance-selector__select"
          value={currentPackageId}
          onChange={this.handleChange}
          id="syos-performance-selector"
        >
          <optgroup label={config.features.packageSelector.defaultText}>
            {packages.map((singlePackage, idx) => {
              return (
                <option value={singlePackage.package_no} key={idx}>
                  {singlePackage.package_name}
                </option>
              );
            })}
          </optgroup>
        </select>
      </div>
    ) : null;
  }
});

export default PackageSelector;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/PackageSelector.js